import { render, staticRenderFns } from "./rtc-config.vue?vue&type=template&id=45ccc369&"
import script from "./rtc-config.vue?vue&type=script&lang=js&"
export * from "./rtc-config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports